import { render, staticRenderFns } from "./PlansList.vue?vue&type=template&id=eca4c7d8&lang=pug"
import script from "./PlansList.vue?vue&type=script&lang=js"
export * from "./PlansList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlanSelect: require('/home/docker/code/frontend/components/PlanSelect.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
